import Link from 'next/link';
import { getCategoryHref } from 'utils/links';

const CategoryListSection = ({categories}) => (
  <section className="mt-[178px] mb-20">
    <h2 className="text-center xl:tp-header-2 md:tp-tablet-header-2 tp-mobile-header-2 mb-[50px]">
      You may also like
    </h2>
    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] md:pl-0 pl-8">
      {categories.slice(0, 9).map((category) => (
        <Link
          key={category.slug}
          href={getCategoryHref(category.slug)}
          className="font-semibold text-[16px] leading-[20px]"
        >
          {category.title}
        </Link>
      ))}
    </div>
  </section>
);

export default CategoryListSection;
